import styled from 'styled-components';

export const wrapper=styled.div`
width: 100%;
`;